// extracted by mini-css-extract-plugin
export default {"page-heading":"prices-page_page-heading__FKUn8","link":"prices-page_link__lJ4BY","page-order":"prices-page_page-order__IGg+J","external-link":"prices-page_external-link__BaqOP"};